export default __webpack_public_path__ + "static/media/gearlm.4539caef.svg";